export default "__VITE_ASSET__055fa892__"